import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { cn } from '../lib/utils.ts';
import { 
  ChevronDown, 
  ChevronRight, 
  Database,
  TrendingUp,
  BarChart3,
  Target,
  Globe,
  Users,
  Activity,
  Calendar,
  Calculator,
  PieChart,
  Package,
  DollarSign,
  Megaphone,
  ShoppingCart
} from 'lucide-react';

export interface CustomNodeData {
  label: string;
  variant: 'primary' | 'secondary' | 'root';
  isExpanded?: boolean;
  hasChildren?: boolean;
  onToggle?: () => void;
  iconName?: string;
  type?: string;
  dec?: string;
}

const getIcon = (iconName?: string) => {
  const iconMap: Record<string, any> = {
    'database': Database,
    'trending': TrendingUp,
    'chart': BarChart3,
    'target': Target,
    'globe': Globe,
    'users': Users,
    'activity': Activity,
    'calendar': Calendar,
    'calculator': Calculator,
    'pie': PieChart,
    'package': Package,
    'dollar': DollarSign,
    'megaphone': Megaphone,
    'cart': ShoppingCart,
  };
  
  return iconMap[iconName || ''] || Database;
};

const FlowchartCustom = memo(({ data, selected }: NodeProps<CustomNodeData>) => {
  const { label, variant, isExpanded, hasChildren, onToggle, iconName, type, dec } = data;
  const IconComponent = getIcon(iconName);


  return (
    <div className="relative hover:shadow-xl hover:scale-105 max-w-[200px] min-w-[200px]"
    onClick={hasChildren ? onToggle : undefined}

    >
      <Handle
        type="target"
        position={Position.Left}
        className="!w-2 !h-2 !bg-[hsl(var(--connector))] !border-none"
      />
      <div style={{borderTopRightRadius:"6px",borderTopLeftRadius:"6px",alignContent:"center",alignItems:"center"}} className={`font-bold text-white p-2 flex gap-2 justify-between ${type === "L1" ? 'bg-blue-900': type === 'L2' ?'bg-green-700' : type === "L3" ? "bg-blue-400" : type === "L4" ? "bg-pink-600" : type === "L5" ? "bg-purple-400"  :'bg-gray-400'}`}>
         <div className='font-bold text-white p-2 flex gap-2 item-center text-[10px]'><IconComponent className="w-4 h-4 flex-shrink-0" /> {label}  </div>
         <div>
         {variant !== 'root'}
          {hasChildren && (
            isExpanded ? (
              <ChevronDown className="w-4 h-4 flex-shrink-0" />
            ) : (
              <ChevronRight className="w-4 h-4 flex-shrink-0" />
            )
          )}
         </div>
      </div>

      <div
        style={{borderBottomRightRadius:"6px",borderBottomLeftRadius:"6px"}}        className={cn(
          "px-2 py-2 font-medium text-sm shadow-lg transition-all duration-300 ",
          hasChildren && "cursor-pointer",
          !hasChildren && "cursor-default",
          selected && "",
          type === 'L1' && "bg-blue-200 text-white  px-3 py-2 font-bold shadow-xl",
          type === 'L2' && "bg-green-100  text-white px-3 py-2 font-bold shadow-xl",
          type === 'L3' && "bg-blue-100  text-white  px-3 py-2 font-bold shadow-xl",
          type === 'L4' && "bg-pink-100  text-white  px-3 py-2 font-bold shadow-xl",
          type === 'L5' && "bg-purple-100  text-white  px-3 py-2 font-bold shadow-xl"


        )}
      >
        <div className="">
        
          <span className={`text-[8px] font-normal ${type === "L1" ? 'text-blue-900' : type === 'L2' ? 'text-green-700' : type === 'L3' ? 'text-blue-400' : type === 'L4' ? 'text-pink-600' : type === 'L5' ? 'text-purple-400' :'text-grey-200'}`}>{dec}</span>

        </div>
      </div>
      {hasChildren && (
    <Handle
    type="source"
    position={Position.Right}
    className="!w-2 !h-2 !bg-[hsl(var(--connector))] !border-none"
  />

      )
      }
  
    </div>
  );
});

FlowchartCustom.displayName = 'FlowchartCustom';

export default FlowchartCustom;
